import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  stagePreview: {
    id: `app.containers.WorkflowEditor.components.StagePreview.stagePreview`,
    defaultMessage: 'Preview',
  },
});
